import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react"; // Import useState and useEffect
import { useDispatch, useSelector } from "react-redux"; // Import Redux hooks
import { loginUser, clearError } from "../features/loginSlice"; // Import the async thunk and clearError action
import { AppDispatch, RootState } from "../store/store"; // Import types for dispatch and state
import { Eye, EyeOff } from "lucide-react"; // 👈 import eye icons

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // 👈 state for visibility toggle

  const { loading, error, isAuth } = useSelector(
    (state: RootState) => state.login
  );

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    dispatch(clearError());
    dispatch(loginUser({ username, password }));
  };

  useEffect(() => {
    if (isAuth) {
      navigate("/dashboard");
    }
  }, [isAuth, navigate]);

  useEffect(() => {
    dispatch(clearError());
    return () => {
      dispatch(clearError());
    };
  }, [dispatch]);

  return (
    <div className="login-background text-[25px]">
      <div className="login-card">
        <h2 className="!text-[25px]">USER LOGIN</h2>
        {error && (
          <p
            style={{ color: "red", textAlign: "center", marginBottom: "1rem" }}
          >
            {error}
          </p>
        )}
        <form onSubmit={handleSubmit}>
          <label htmlFor="email">User Name</label>
          <input
            id="email"
            type="text"
            placeholder="Enter User Name"
            value={username}
            onChange={(e) => setUserName(e.target.value)}
            required
            aria-label="Email Input"
            className="placeholder:!text-[16px] !text-[16px]"
          />

          <label htmlFor="password">Password</label>
          <div className="relative">
            <input
              id="password"
              type={showPassword ? "text" : "password"} // 👈 toggle type
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              aria-label="Password Input"
              className="placeholder:!text-[16px] !text-[16px] pr-10 w-full" // add padding for eye
            />
            <button
              style={{
                width: "10px",
                backgroundColor: "transparent",
                color: "black",
              }}
              type="button"
              onClick={() => setShowPassword(!showPassword)} // 👈 toggle
              className="absolute right-3 top-1/4 -translate-y-1/2 text-gray-600"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="hover:!bg-green-600 mt-3"
          >
            {loading ? "LOGGING IN..." : "LOG IN"}
          </button>
          <div className="login-links !text-[20px]">
            <Link to="/login-first-time">First Time Login ?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
